import { forwardRef, useState } from "react";

import { TextInput, TextInputProps } from "../TextInput/TextInput";

import { ToggleVisibilityButton } from "./components/ToggleVisibilityButton";
import { ReactComponent as LockIcon } from "./icons/lock.svg";

export const PasswordInput = forwardRef<HTMLInputElement, TextInputProps>(
  (props, ref) => {
    const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false);

    return (
      <TextInput
        {...props}
        type={isPasswordVisible ? "text" : "password"}
        ref={ref}
        startAdornment={<LockIcon />}
        endAdornment={
          <ToggleVisibilityButton
            isVisible={isPasswordVisible}
            togglePasswordVisibility={() =>
              setIsPasswordVisible((prev) => !prev)
            }
          />
        }
      />
    );
  }
);
